import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import ReactTooltip from 'react-tooltip'
import config from '../../config'
import container from '../../helpers/container'
import {
  AboutBanner,
  Works,
  Link,
  LinkIcon,
  GetStartedInput,
  ScreenedCompanies,
  Grade,
  Changelog
} from '../../components'
import * as searchActions from 'redux/modules/search'
import Styles from './HowItWorks.css'


@connect(
  state => ({
    result: state.company.result,
    searching: state.company.loading,
    searched: state.company.loaded,
    error: state.company.error
  }),
  searchActions)
@CSSModules(Styles)
export default class HowItWorks extends Component {
  static propTypes = {
    searching: PropTypes.bool,
    searched: PropTypes.bool,
    error: PropTypes.object,
    result: PropTypes.array,
  }

  constructor(props) {
    super(props)
    this.state = { }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
    this.props.companies()
  }

  render() {
    const companyList = this.props.result && this.props.result.length>0 ?
      this.props.result :
      null

    const title = 'How it works'
    const description = 'Get your money out of the prison industrial complex. Prison Free Funds tracks thousands of mutual funds commonly found in retirement plans.'
    const url = config.domain + config.routes.howitworks

    const bannerImage = 'green'
    const bannerHeadline = 'How it works'
    const bannerSubtitle = 'Prison Free Funds methodology'

    const sriIcon = require('../../../static/images/sri.png')
    const ussifIcon = require('../../../static/images/ussif-logo.png')
    // const cleanChartImg = require('../../../static/images/clean-chart.png')
    const dirtyChartImg = require('../../../static/images/dirty-chart.png')
    const categorySwitchesImg = require('../../../static/images/category-switches.png')
    const categoryChartImg = require('../../../static/images/category-chart.png')
    const afscLogoImg = require('../../../static/images/AFSC-logo.jpg')
    const investigateLogoImg = require('../../../static/images/Investigate-logo.jpg')
    const geoGroupIcon = require('../../../static/images/GEOGroup-gray.png')
    const coreCivicIcon = require('../../../static/images/CoreCivic-gray.png')
    const ferrovialIcon = require('../../../static/images/Ferrovial-gray.png')
    const sercoIcon = require('../../../static/images/Serco-gray.png')
    const sodexoIcon = require('../../../static/images/Sodexo-gray.png')
    const mitieIcon = require('../../../static/images/Mitie-gray.png')
    const g4sIcon = require('../../../static/images/G4S-gray.png')

    const highIcon = (
      <span styleName='high-icon'>
        <LinkIcon faclass='fa-exclamation-triangle'/>
      </span> 
    )
    const extremeIcon = (
      <span styleName='extreme-icon'>
        <LinkIcon faclass='fa-exclamation-triangle'/>
      </span> 
    )

    return (
      <div>
        {container.helmet(title, description, url)}
        <div styleName='image-banner'>
          <div styleName='image-banner-container'>
            <div styleName='image-banner-container-inner'>
              <div styleName={'image-banner-'+bannerImage}>
                <div styleName='image-banner-headline'>
                  {bannerHeadline}
                </div>
                <div styleName='image-banner-subtitle'>
                  {bannerSubtitle}
                </div>
              </div>
            </div>
          </div>
        </div>
         <div styleName='page'>
          <div styleName='container'>
            <div styleName='container-inner'>
              <div styleName='lede'>
                <strong>Prison Free Funds</strong> covers thousands of the most popular mutual funds and exchange-traded funds (ETFs), the type of investments most common in personal portfolios and retirement plans like employer-offered 401(k)s.
              </div>
              <Changelog />
             </div>
           </div>
         </div>
        <Works/>
        <div styleName='how-it-works'>
          <div styleName='how-it-works-inner'>
            <div styleName='answer-title'>
              Mutual funds
            </div>
            <div styleName='answer-info'>
              <p>
                Mutual funds are collections of stocks bundled together, often hundreds or thousands of companies. Along with similar products called exchange-traded funds, or ETFs, they are some of the most popular investment products for retirement plans and personal investing. Investing in so many different company stocks at once helps diversify investment risk, but it makes it difficult to find out and track exactly what companies are inside the funds you're invested in. That's where we come in. We examine every holding in thousands of funds, checking to see if any of the fund’s investments are flagged by our prison industrial complex screen.
              </p>
            </div>

            <div styleName='answer-title'>
              Prison industrial complex screen
            </div>
            <div styleName='answer-info'>
              <p>
                <strong>Prison Free Funds</strong> originated with data provided by the <Link to={'https://www.afsc.org/'} title='American Friends Service Committee (AFSC)' xstrong>American Friends Service Committee (AFSC)</Link> <Link to={'https://investigate.afsc.org/'} title='Investigate: a project of American Friends Service Committee' xstrong>The Investigate project</Link>, from <Link to={'https://www.afsc.org/key-issues/issue/economic-activism'} title='Economic Activism Program | AFSC' xstrong>AFSC’s Economic Activism Program</Link>, tracked companies involved in oppressive state violence structures in order to promote standards for corporate social responsibility and respect for human rights. Their research database highlighted and profiled the main publicly-traded companies involved in the prison and border industries.
              </p>
              { /* <p>
                Learn more about AFSC,  the Investigate tool, and their company scoring rubric at <Link
                  to={config.links.afsc}
                  title='American Friends Service Committee'
                  xstrong
                >afsc.org</Link> and <Link
                  to={config.links.investigate}
                  title='Investigate: a project of American Friends Service Committee'
                  xstrong
                >investigate.afsc.org</Link>.
              </p> */ }
              { /* <div styleName='img-wrap'>
                <Link
                  to={config.links.afsc}
                  title='American Friends Service Committee'
                >
                  <img
                    src={afscLogoImg}
                    alt='American Friends Service Committee'
                    styleName={'img-border'}
                  />
                </Link>
                <Link
                  to={config.links.investigate}
                  title='Investigate: a project of American Friends Service Committee'
                >
                  <img
                    src={investigateLogoImg}
                    alt='Investigate: a project of American Friends Service Committee'
                    styleName={'img-border'}
                  />
                </Link>
              </div> */ }

              <p>
                As of 2026, <i>As You Sow</i> has taken responsibility for updating the Prisons & Borders company list used by Prison Free Funds.
                We use USASpending.gov and other data sources to identify companies with business relationships to the prison and border industries.
              </p>

            </div>
            <div styleName='sidebar'>
              <div styleName='sidebar-title'>
                <LinkIcon faclass='fa-info-circle' nospace/>
                &nbsp;
                <em>American Friends Service Committee (AFSC)</em>
              </div>
              <div styleName='sidebar-info'>
                <p>
                  Founded in 1917, AFSC is a Quaker organization that promotes lasting peace with justice, as a practical expression of faith in action. AFSC has a long history of supporting non-violent campaigns through research, training, and strategy consultation. Learn more about AFSC at <Link
                    to={config.links.afsc}
                    title='American Friends Service Committee'
                    xstrong
                  >afsc.org</Link>.
                </p>
              </div>
            </div>
            <div styleName='answer-title'>
              The prison and border industries
            </div>
            <div styleName='answer-info'>
              <p>
                On <strong>Prison Free Funds</strong>, we focus on two aspects of the prison industrial complex: companies involved in the prison industry (such as private for-profit prison operators and prison services providers), and companies involved in the militarization of borders and the policing of immigration.
              </p>
            </div>
            <div styleName='answer-info'>
              <ScreenedCompanies companyList={companyList}/>
            </div>
            <div styleName='answer-title'>
              Higher risk companies and private prison operators
            </div>
            <div styleName='answer-info'>
              <p>
                Using the Prisons & Borders company scoring rubric, some companies are identified as <strong>higher risk</strong>, marked with this symbol: {highIcon}
              </p>
              <p>
                Additionally, some companies are identified as <span styleName='bred'>private prison operators</span>. These companies are identified as directly operating or managing private prison or immigrant detention facilities. They are marked with this symbol: {extremeIcon}
              </p>
              <div styleName='img-wrap'>
                <img
                  src={coreCivicIcon}
                  alt='CoreCivic'
                  styleName={'img-border'}
                />
                <img
                  src={ferrovialIcon}
                  alt='Ferrovial'
                  styleName={'img-border'}
                />
                <img
                  src={g4sIcon}
                  alt='G4S'
                  styleName={'img-border'}
                />
                <img
                  src={geoGroupIcon}
                  alt='GEO Group'
                  styleName={'img-border'}
                />
                <img
                  src={mitieIcon}
                  alt='MITIE Group'
                  styleName={'img-border'}
                />
                <img
                  src={sercoIcon}
                  alt='Serco'
                  styleName={'img-border'}
                />
                <img
                  src={sodexoIcon}
                  alt='Sodexo'
                  styleName={'img-border'}
                />
              </div>
            </div>
            <div styleName='sidebar'>
              <div styleName='sidebar-title'>
                <LinkIcon faclass='fa-info-circle' nospace/>
                &nbsp;
                <em>Company scoring rubric</em>
              </div>
              <div styleName='sidebar-info'>
                <p>
                  The company scoring rubric is based on an assessment of three criteria: the <strong>salience</strong> of the human rights violation, the company's <strong>responsibility</strong> for the violation, and the company's <strong>responsiveness</strong>. Each criterion is evaluated on a 1-5 point scale, from least to most severe, leading to an overall score of 3-15 points for each company. For Prison Free Funds, companies that earned more than 10 points in the prison industry or border industry categories are marked as "higher risk".
                </p>
                { /* Learn more at <Link to={config.links.investigate} title='Investigate: a project of American Friends Service Committee' xstrong>investigate.afsc.org</Link> */ }
              </div>
            </div>
            <div styleName='answer-title'>
              Screening funds
            </div>
            <div styleName='answer-info'>
              <p>
                Once we’ve checked to see if any of a fund’s holdings get flagged by our prison industrial complex screen, we calculate some summary statistics. We calculate the total number of flagged holdings in the fund, the total amount in USD of the fund’s assets that are invested in those companies by the fund, and the total percentage of the fund portfolio they account for. These totals are also broken down by holding category (prison industry and border industry), and by holdings that are higher risk or private prison operators. We also show the full list of any holdings that were flagged.
              </p>
            </div>
            <div styleName='sidebar'>
              <div styleName='sidebar-title'>
                <LinkIcon faclass='fa-info-circle' nospace/>
                &nbsp;
                <em>Stocks and bonds</em>
              </div>
              <div styleName='sidebar-info'>
                <p>
                  Mutual funds can invest in a range of different investments, but the most popular are company stocks, or equity shares. The Invest Your Values screening system checks a fund’s stock holdings against the prison industrial complex screen, but checking non-stock holdings like bonds is currently outside our capabilities. Each fund will have a <strong>percent rated figure</strong> that accounts for what percentage of the fund’s portfolio was invested in stock holdings that we could check against the prison industrial complex screen. If a fund is 95% rated it’s possible that there could be exposure to the companies on the prison industrial complex screen via corporate bonds or other non-stock investments in that un-rated 5%. To be included in our database, a fund has to be at least 40% rated – i.e. at least 40% invested in company stocks.
                </p>
              </div>
            </div>
            <div styleName='sidebar'>
              <div styleName='sidebar-title'>
                <LinkIcon faclass='fa-info-circle' nospace/>
                &nbsp;
                <em>Measuring long holdings only</em>
              </div>
              <div styleName='sidebar-info'>
                <p>
                  When calculating a fund's exposure to a screen list, we only consider the portfolio's long investments, ignoring any shorts or liabilities. The formula for holding weight is <em>holding market value divided by the sum of the market value for all long holdings in the portfolio.</em>
                </p>
              </div>
            </div>
            <div styleName='answer-title'>
              Grading funds
            </div>
            <div styleName='answer-info'>
              <p>
                Based on the screen results, a fund is assigned one of five letter grades.
              </p>
              <div styleName='risk-bullet'>
                <div styleName='score-wrap'>
                  <Grade grade={1}/>
                </div>
                <p styleName='screen-icon-label'>
                  None of the fund’s stock holdings were flagged by the prison industrial complex screen.
                </p>
              </div>
              <div styleName='risk-bullet'>
                <div styleName='score-wrap'>
                  <Grade grade={2}/>
                </div>
                <p styleName='screen-icon-label'>
                  Some of the fund’s stock holdings were flagged by the prison industrial complex screen, but no higher risk or private prison operator companies were found.
                </p>
              </div>
              <div styleName='risk-bullet'>
                <div styleName='score-wrap'>
                  <Grade grade={3}/>
                </div>
                <p styleName='screen-icon-label'>
                  Some of the fund’s stock holdings were flagged by the prison industrial complex screen, and some higher risk companies were found, but the exposure to higher risk companies was below 1%, and no private prison operator companies were found.
                </p>
              </div>
              <div styleName='risk-bullet'>
                <div styleName='score-wrap'>
                  <Grade grade={4}/>
                </div>
                <p styleName='screen-icon-label'>
                  Some of the fund’s stock holdings were flagged by the prison industrial complex screen, and some higher risk companies were found, but the exposure to higher risk companies was below 2%, and no private prison operator companies were found.
                </p>
              </div>
              <div styleName='risk-bullet'>
                <div styleName='score-wrap'>
                  <Grade grade={5}/>
                </div>
                <p styleName='screen-icon-label'> 
                  Some of the fund’s stock holdings were flagged by the prison industrial complex screen, and some higher risk companies were found, and the exposure to higher risk companies was above 2%, and/or private prison operator companies were found.
                </p>
              </div>
            </div>
            <div styleName='sidebar'>
              <div styleName='sidebar-title'>
                <LinkIcon faclass='fa-info-circle' nospace/>
                &nbsp;
                <em>An F grade for private prison operator investments</em>
              </div>
              <div styleName='sidebar-info'>
                <p>
                  Private prison operators are among the companies most directly intertwined with the expansion of mass incarceration and the prison industrial complex. For these seven companies, if a fund invests, it’s an automatic F grade on <strong>Prison Free Funds</strong> – even if it’s only a fraction of a percent of the fund’s total portfolio.
                </p>
              </div>
            </div>
            <div styleName='answer-title'>
              Finding top-scoring investments
            </div>
            <div styleName='answer-info'>
              <p>
                On our <Link to={config.routes.clean} title='Search funds | Prison Free Funds' xstrong>search page</Link>, you can filter and sort results to find the funds that fit your investing needs. For example, you can filter to only see funds that earn a certain grade on <strong>Prison Free Funds</strong>, or only search for funds that are offered by a specific asset manager. By default, the search results are sorted to highlight the largest funds that earn the top grade and are sustainable investments. 
              </p>
            </div>
            <div styleName='answer-title'>
              Socially sustainable investing
            </div>
            <div styleName='answer-info'>
              <p>
                Some funds actively choose to invest responsibly by considering the prison industrial complex or other environmental and social issues when selecting companies to invest in. If you're thinking about avoiding investments in the prison industrial complex, sustainable funds can be a good place to start. These funds often deliberately seek out companies that are not directly benefitting from the prison or border industries.
              </p>
              <p>
                Funds marked as having a sustainability mandate show this icon:
              </p>
              <img
                styleName='sri'
                src={sriIcon}
                alt='Socially responsible fund'
                data-multiline={true}
                data-effect={'solid'}
                data-html={true}
                data-for='sri-icons-tooltip'
                data-place='bottom'
                data-tip="<div style='max-width:200px;'>Designated a sustainably-mandated fund by Morningstar. Sustainably-mandated funds consider issues like the environment and human rights.</div>"
              />
              <p>
                Funds that are members of <Link to={config.links.ussif} title='The Forum for Sustainable and Responsible Investment' xstrong>The Forum for Sustainable and Responsible Investment</Link>, an industry group advancing sustainable, responsible, and impact investing, show this icon:
              </p>
              <img
                styleName='ussif'
                src={ussifIcon}
                alt='Member of US-SIF, the Forum for Sustainable and Responsible Investment'
                data-multiline={true}
                data-effect={'solid'}
                data-html={true}
                data-for='sri-icons-tooltip'
                data-place='bottom'
                data-tip="<div style='max-width:200px;'>Member of US-SIF, the Forum for Sustainable and Responsible Investment</div>"
              />
              <ReactTooltip id='sri-icons-tooltip'/>
            </div>
            <div styleName='answer-title'>
              Sustainable investing can offer competitive returns
            </div>
            <div styleName='answer-info'>
              <p>
                While people may become interested in sustainable investing because of personal values and goals, that doesn't mean they're not looking for a competitive financial return on their investments. Fortunately, <Link to={config.links.ussifperf} title={'Financial Performance with Sustainable Investing | US-SIF'} xstrong>the evidence is clear:</Link> sustainable and responsible investors do not have to sacrifice returns to align investments with their values. On <strong>Prison Free Funds</strong>, you can also see some basic information on fund performance and expense ratio.
              </p>
            </div>
            <div styleName='answer-title'>
              Action toolkit to move your money
            </div>
            <div styleName='answer-info'>
              <p>
                When you're done looking up funds and finding the data you need, what's next? You can learn how to make a change and move your money with our <Link to={config.routes.toolkit} title={'Prison industrial complex-free action toolkit | Prison Free Funds'} xstrong>prison industrial complex-free action toolkit</Link>. Whether you’re an individual investor or if your investments are in your employer-sponsored plan at work, our step-by-step toolkit can help.
              </p>
            </div>
            <div styleName='answer-title'>
              Can't find what you're looking for?
            </div>
            <div styleName='answer-info'>
              <p>
                We don't have everything in our database. We only screen mutual funds that own direct stock investments. Looking for your favorite fund and can&rsquo;t find it? <Link to={config.links.contact} title='Contact | As You Sow' xstrong>Get in touch</Link> and let us know, and we may be able to help. We're also a non-profit, and with more resources, we could expand our site &mdash; <Link xstrong={true} to={config.links.donate} title='Donate to As You Sow'>make a gift today to support our work.</Link>
              </p>
            </div>
          </div>
        </div>
        <GetStartedInput />
        <div styleName='ab-container'>
          <div styleName='ab-container-inner'>
            <AboutBanner />
          </div>
        </div>
      </div>
    )
  }
}
